import React from "react";
import Lottie from "lottie-react";
import animationData from "./imageLoader.json";

const ImageLoader = ({ width, height }) => {
    return (
        <div style={{ width, height }}>
            <Lottie
                animationData={animationData}
                loop={true}
                style={{ width: width, height: height }}   
            />
        </div>
    );
};

export default ImageLoader;
